import httpClient from './httpClient';

// 환경 변수에서 API URL 가져오기
const ADMIN_ENDPOINT = `/admin`;
const USER_PAYMENT_ENDPOINT = `/admin/user-payment`;
const CREATE_ACCOUNT_ENDPOINT = `/admin/create-account`;

/**
 * 현재 사용자가 관리자인지 확인합니다
 * @returns {boolean} 관리자 여부
 */
export const isAdmin = () => {
  try {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) return false;
    
    const user = JSON.parse(userStr);
    return user && user.userid === 1;
  } catch (error) {
    console.error('관리자 권한 확인 중 오류:', error);
    return false;
  }
};

/**
 * 시스템 상태를 확인합니다
 * @returns {Promise} API 응답
 */
// (이전) 시스템 상태/DB 상태 엔드포인트는 home 서비스로 이동함 (src/services/home.js)

// ==================== 로그 정보 관리 ====================

/**
 * 에러 로그를 조회합니다
 * @param {Object} params - 쿼리 파라미터 {userid, page, limit}
 * @returns {Promise} API 응답
 */
export const getErrorLogs = async (params = {}) => {
  try {
    const response = await httpClient.get(`${ADMIN_ENDPOINT}/log-info/error`, { params });
    return response.data;
  } catch (error) {
    console.error('에러 로그 조회 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 에러 로그를 전체 삭제합니다
 * @returns {Promise} API 응답 { success, message }
 */
export const deleteAllErrorLogs = async () => {
  try {
    const response = await httpClient.delete(`${ADMIN_ENDPOINT}/log-info/error`);
    return response.data;
  } catch (error) {
    console.error('에러 로그 전체 삭제 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 정보 로그를 전체 삭제합니다
 * @returns {Promise} API 응답 { success, message }
 */
export const deleteAllInfoLogs = async () => {
  try {
    const response = await httpClient.delete(`${ADMIN_ENDPOINT}/log-info/info`);
    return response.data;
  } catch (error) {
    console.error('정보 로그 전체 삭제 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 금지어 로그를 전체 삭제합니다
 * @returns {Promise} API 응답 { success, message }
 */
export const deleteAllBanLogs = async () => {
  try {
    const response = await httpClient.delete(`${ADMIN_ENDPOINT}/log-info/ban`);
    return response.data;
  } catch (error) {
    console.error('금지어 로그 전체 삭제 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 정보 로그를 조회합니다
 * @param {Object} params - 쿼리 파라미터 {page, limit} (userid 필터링 없음)
 * @returns {Promise} API 응답
 */
export const getInfoLogs = async (params = {}) => {
  try {
    const response = await httpClient.get(`${ADMIN_ENDPOINT}/log-info/info`, { params });
    return response.data;
  } catch (error) {
    console.error('정보 로그 조회 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 금지어 로그를 조회합니다
 * @param {Object} params - 쿼리 파라미터 {page, limit}
 * @returns {Promise} API 응답
 */
export const getBanLogs = async (params = {}) => {
  try {
    const response = await httpClient.get(`${ADMIN_ENDPOINT}/log-info/ban`, { params });
    return response.data;
  } catch (error) {
    console.error('금지어 로그 조회 중 오류 발생:', error);
    throw error;
  }
};

// ==================== 사용자 관리 ====================

/**
 * 사용자 정보를 조회합니다
 * @param {Object} params - 쿼리 파라미터 {identifier, page, limit}
 * @returns {Promise} API 응답
 */
export const getUsersInfo = async (params = {}) => {
  try {
    const response = await httpClient.get(`${USER_PAYMENT_ENDPOINT}/users`, { params });
    return response.data;
  } catch (error) {
    console.error('사용자 정보 조회 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 사용자 정보를 수정합니다
 * @param {string} identifier - 사용자 식별자 (email 또는 id)
 * @param {Object} updateData - 수정할 사용자 데이터 {expired_at, tracking_market_count, register_product_count}
 * @returns {Promise} API 응답
 */
export const updateUserInfo = async (identifier, updateData) => {
  try {
    const response = await httpClient.put(`${USER_PAYMENT_ENDPOINT}/users/${identifier}`, updateData);
    return response.data;
  } catch (error) {
    console.error('사용자 정보 수정 중 오류 발생:', error);
    throw error;
  }
};

/**
 * 로컬 계정을 생성합니다
 * @param {Object} accountData - 계정 생성 데이터
 * @returns {Promise} API 응답
 */
export const createLocalAccount = async (accountData) => {
  try {
    const response = await httpClient.post(`${CREATE_ACCOUNT_ENDPOINT}/local`, accountData);
    return response.data;
  } catch (error) {
    console.error('로컬 계정 생성 중 오류 발생:', error);
    throw error;
  }
};
